export default __webpack_public_path__ + "static/WorkSans-Regular-9b2d600bfd1585982aff7de446f42824.woff2";